const HELP_PAGE_NOT_FOUND_ID = 0;

export function getUri(path = '') {
    return `${window.webApiRootUrl}${path}`;
}

export function getNonApiUri(path = '') {
    return `${window.rootUrl}${path}`;
}

export function getPageHelpUri(helpAddress, pageHelpId) {
    if (!helpAddress) {
        return null;
    }

    if (pageHelpId) {
        return `${helpAddress}${pageHelpId}`;
    }

    return `${helpAddress}${HELP_PAGE_NOT_FOUND_ID}`;
}

export function getPermissionsUri() {
    return getUri(`recommendedFlights/getPermissions`);
}
